import { activeEditor$, ButtonWithTooltip, insertJsx$, JsxEditorProps, useCellValues, usePublisher } from "@mdxeditor/editor";
import { Edit, Map } from "@mui/icons-material";
import { Box, CircularProgress, Dialog, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { InsertMapPage, StartDataProps } from "./mapComponent";
import { MapItemOnText } from "./mapItem";
import { googleSatelite, HidroLayer, HidroLayerGroup, PaintTypes } from "../../mapa";
import { getShapes, SelectedItem } from "../../barragem";
import { RequestError } from "../../../services";
import { ErrorModal } from "../../modals";
import { generateRandomHash } from "../../../core";
import { useParams } from "react-router-dom";

export const MapEditor: React.ComponentType<JsxEditorProps> = (props) => {
  const { barragem } = useParams();

  const insertJsx = usePublisher(insertJsx$);
  const [open, setOpen] = useState(false);
  const [editor] = useCellValues(activeEditor$);
  const editable = editor?.isEditable();
  const mapData = JSON.parse(props.mdastNode.attributes[0].value?.toString() ?? "{}") as StartDataProps;

  const [layersMap, setLayersMap] = useState<HidroLayerGroup | RequestError | undefined>(undefined);


  useEffect(() => {
    if (!barragem) {
      setLayersMap({
        error: "Erro",
        message: "Barragem inválida",
      });
      return;
    }

    const getLayers = async () => {
      const layersAdd: SelectedItem[] = mapData.layers.filter((layer) => layer.selected);
      const stylesAdd: PaintTypes[] = layersAdd.map((layer) => {
        const stylesNow = (mapData.layersStyles ?? []).filter((style) => (style.layer === layer.layer && style.file === layer.name));
        if (stylesNow.length === 0) return {};
        return stylesNow[0].style;
      });

      const layersData = await getShapes(parseInt(barragem!), layersAdd, stylesAdd);
      if (!("error" in layersData)) {
        layersData.push(new HidroLayer({
          name: "Mapa",
          showing: true,
          layer: googleSatelite(),
        }));
      }
      setLayersMap(layersData);
    };

    getLayers();
  }, []);

  const handleEdit = () => {
    setOpen(true);
  };
  const handleInsert = (opts: StartDataProps) => {
    insertJsx({
      name: 'MapEditor',
      kind: 'flow',
      props: { chartData: JSON.stringify(opts) }
    });
    setOpen(false);
  };

  return <>
    <MapDialog
      open={open}
      startData={mapData}
      onInsert={handleInsert}
      onClose={() => setOpen(false)}
    />
    <Box sx={{
      width: "100%",
      height: `${mapData.height + 80}px`,
      display: "flex",
      flexDirection: "column",
      padding: "15px",
      border: editable ? "1px solid black" : undefined,
      borderRadius: "15px",
      alignItems: "center",
    }}>
      {editable &&
        <Box sx={{
          position: "relative",
          width: "100%",
        }}>
          <Box sx={{
            position: "absolute",
            top: "0px",
            right: "0px",
            borderRadius: "5px",
            display: "flex",
            flexDirection: "row",
          }}>
            <IconButton onClick={handleEdit}><Edit /></IconButton>
          </Box>
        </Box>
      }
      <Box
        sx={{
          height: `${mapData.height}px`,
          width: `${mapData.width}px`,
        }}
      >
        {!layersMap && <CircularProgress color="inherit" />}
        {layersMap && "error" in layersMap && <ErrorModal {...layersMap} />}
        {layersMap && !("error" in layersMap) &&
          <MapItemOnText
            key={generateRandomHash(8)}
            title={mapData.title}
            position={mapData.position}
            width={mapData.width}
            height={mapData.height}
            layers={layersMap}
          />
        }
      </Box>
    </Box>
  </>;
};

export const InsertMap = () => {
  const insertJsx = usePublisher(insertJsx$);
  const [open, setOpen] = useState(false);

  const handleInsert = (opts: StartDataProps) => {
    insertJsx({
      name: 'MapEditor',
      kind: 'flow',
      props: { mapData: JSON.stringify(opts) }
    });
    setOpen(false);
  };

  return (
    <>
      <MapDialog
        open={open}
        onInsert={handleInsert}
        onClose={() => setOpen(false)}
      />
      <ButtonWithTooltip
        title="Insert Map"
        onClick={() => setOpen(true)}
      >
        <Map />
      </ButtonWithTooltip>
    </>
  );
};

interface MapDataProps {
  open: boolean;
  startData?: StartDataProps;
  onInsert?: (opts: StartDataProps) => void;
  onClose?: () => void;
}
const MapDialog: React.FC<MapDataProps> = (data) => {
  return <Dialog
    open={data.open}
    onClose={data.onClose}
    fullScreen={true}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >

    <InsertMapPage
      startData={data.startData}
      onClose={data.onClose}
      onInsert={data.onInsert}
    />
  </Dialog>;
};